import { Permission } from 'accesscontrol';
import UserModule from '@/store/modules/user';
import AppModule from '@/store/modules/app';

// eslint-disable-next-line import/prefer-default-export
export class FWAccessControl {
  static getRole() {
    if (UserModule.currentRole) {
      return UserModule.currentRole;
    }
    return '';
  }

  static get AC() {
    return AppModule.accesscontrol;
  }

  static hasAccess(permission: Permission, attribute?: string): boolean {
    try {
      const all = permission.attributes.includes('*');
      const some = permission.attributes.filter(e => e[0] !== '!').length > 0;
      if (attribute) {
        const denied = permission.attributes.includes(`!${attribute}`);
        const access = permission.attributes.includes(`${attribute}`);
        return !denied && (all || access);
      }
      return all || some;
    } catch (err) {
      console.log(err);
    }
    return false;
  }

  static hasRead(resource: string, attribute?: string): boolean {
    const role = this.getRole();
    if (role) {
      return this.hasAccess(this.AC.can(role).readOwn(resource), attribute);
    }
    return false;
  }

  static hasCreate(resource: string, attribute?: string): boolean {
    const role = this.getRole();
    if (role) {
      return this.hasAccess(this.AC.can(role).createOwn(resource), attribute);
    }
    return false;
  }

  static hasUpdate(resource: string, attribute?: string): boolean {
    const role = this.getRole();
    if (role) {
      return this.hasAccess(this.AC.can(role).updateOwn(resource), attribute);
    }
    return false;
  }

  static hasDelete(resource: string, attribute?: string): boolean {
    const role = this.getRole();
    if (role) {
      return this.hasAccess(this.AC.can(role).deleteOwn(resource), attribute);
    }
    return false;
  }
}
